// extracted by mini-css-extract-plugin
export var darkVariant = "toggle-module--darkVariant--85dab";
export var lavender = "toggle-module--lavender--fa762";
export var lightVariant = "toggle-module--lightVariant--bae00";
export var pricing = "toggle-module--pricing--b0b21";
export var pricingText = "toggle-module--pricingText--424dc";
export var rounded = "toggle-module--rounded--70972";
export var selected = "toggle-module--selected--ffea6";
export var short = "toggle-module--short--36f23";
export var text = "toggle-module--text--d4f73";
export var toggle = "toggle-module--toggle--b403f";
export var toggleButton = "toggle-module--toggleButton--6071f";
export var toggleButtonContainer = "toggle-module--toggleButtonContainer--3f3f0";
export var wide = "toggle-module--wide--9d2c6";